import React from "react"
import { useRouteMatch, Switch, Route } from "react-router-dom"

import ConsoleLayout from "../ConsoleLayout"
import ClientBatchingPage from "../features/clientBatching/ClientBatchingPage"
import RunReviewPage from "../features/clientBatching/RunReviewPage"
import RunPreflightPage from "../features/clientBatching/RunPreflightPage"
import RunFinalizePage from "../features/clientBatching/RunFinalizePage"
import RunFlaggedPage from "../features/clientBatching/RunFlaggedPage"
import TodaysRunsPage from "../features/clientBatching/TodaysRunsPage"
import ClientBatchingNav from "../features/clientBatching/components/ClientBatchingNav"

export default function ClientBatchingRoutes() {
    const { path } = useRouteMatch()

    return (
        <Switch>
            <Route exact path={path}>
                <ConsoleLayout
                    header={<ClientBatchingNav activeTab="picker" />}
                    highlightTab="clientBatching"
                    body={<ClientBatchingPage />}
                    bodyFullWidth
                />
            </Route>

            <Route exact path={`${path}/today`}>
                <ConsoleLayout
                    header={<ClientBatchingNav activeTab="today" />}
                    highlightTab="clientBatching"
                    body={<TodaysRunsPage />}
                    bodyFullWidth
                />
            </Route>

            <Route exact path={`${path}/runs/:runId/preflight`}>
                <ConsoleLayout
                    header={<ClientBatchingNav activeTab="preflight" />}
                    highlightTab="clientBatching"
                    body={<RunPreflightPage />}
                    bodyFullWidth
                />
            </Route>

            <Route exact path={`${path}/runs/:runId/flagged`}>
                <ConsoleLayout
                    header={<ClientBatchingNav activeTab="flagged" />}
                    highlightTab="clientBatching"
                    body={<RunFlaggedPage />}
                    bodyFullWidth
                />
            </Route>

            <Route exact path={`${path}/runs/:runId/finalize`}>
                <ConsoleLayout
                    header={<ClientBatchingNav activeTab="finalize" />}
                    highlightTab="clientBatching"
                    body={<RunFinalizePage />}
                    bodyFullWidth
                />
            </Route>

            <Route exact path={`${path}/runs/:runId`}>
                <ConsoleLayout
                    header={<ClientBatchingNav activeTab="review" />}
                    highlightTab="clientBatching"
                    body={<RunReviewPage />}
                    bodyFullWidth
                />
            </Route>
        </Switch>
    )
}
